// Mismo criterio que el resto de Cajas.
export const esSubRolContable = (subRol) => String(subRol || "").toLowerCase().startsWith("cont");

export const esRolAdminGerenteContable = (user) =>
  user?.role === "admin" || user?.role === "gerente" || esSubRolContable(user?.sub_rol);
